import React, { useState, useEffect } from "react";

const TOKEN_KEY = "impulsion-diagrams-token";

export const getAuthToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

export const getAuthHeaders = (): Record<string, string> => {
  const token = getAuthToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const AuthGate: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [checking, setChecking] = useState(true);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const token = getAuthToken();
    if (!token) {
      setChecking(false);
      return;
    }
    fetch("/api/auth/check", {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => {
        if (r.ok) setAuthenticated(true);
        else localStorage.removeItem(TOKEN_KEY);
        setChecking(false);
      })
      .catch(() => setChecking(false));
  }, []);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      const res = await fetch("/api/auth/login", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password }),
      });
      if (res.ok) {
        const { token } = await res.json();
        localStorage.setItem(TOKEN_KEY, token);
        setAuthenticated(true);
      } else {
        setError("Mot de passe incorrect");
      }
    } catch {
      setError("Erreur de connexion");
    }
  };

  if (checking) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          fontFamily: "Inter, sans-serif",
          color: "#666",
        }}
      >
        Chargement...
      </div>
    );
  }

  if (!authenticated) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100vh",
          background: "#f8f9fa",
          fontFamily: "Inter, -apple-system, sans-serif",
        }}
      >
        <form
          onSubmit={handleLogin}
          style={{
            background: "#fff",
            borderRadius: 12,
            padding: "40px 36px",
            boxShadow: "0 4px 24px rgba(0,0,0,0.1)",
            width: 360,
            textAlign: "center",
          }}
        >
          <div
            style={{
              width: 48,
              height: 48,
              borderRadius: 12,
              background: "#4285F4",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 16px",
              fontSize: 22,
              color: "#fff",
              fontWeight: 700,
            }}
          >
            ID
          </div>
          <h1
            style={{
              fontSize: 20,
              fontWeight: 600,
              color: "#202124",
              marginBottom: 4,
            }}
          >
            Impulsion Diagrams
          </h1>
          <p
            style={{
              fontSize: 13,
              color: "#5f6368",
              marginBottom: 24,
            }}
          >
            Entrez le mot de passe pour acceder a l'outil
          </p>

          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Mot de passe"
            autoFocus
            style={{
              width: "100%",
              padding: "12px 14px",
              borderRadius: 8,
              border: error ? "2px solid #EA4335" : "1.5px solid #dadce0",
              fontSize: 15,
              outline: "none",
              marginBottom: 12,
              fontFamily: "Inter, sans-serif",
            }}
          />

          {error && (
            <p
              style={{
                color: "#EA4335",
                fontSize: 13,
                marginBottom: 12,
              }}
            >
              {error}
            </p>
          )}

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              borderRadius: 8,
              border: "none",
              background: "#4285F4",
              color: "#fff",
              fontSize: 15,
              fontWeight: 600,
              cursor: "pointer",
              fontFamily: "Inter, sans-serif",
            }}
          >
            Se connecter
          </button>
        </form>
      </div>
    );
  }

  return <>{children}</>;
};
